/*es6-symbol/index*/
function _(require, module, exports) {
    module.exports = require(326    /* ./is-implemented */)() ? Symbol : require(328    /* ./polyfill */);
}